var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 26.8333H20.0007V15.3333C26.3429 15.3333 31.5007 20.4911 31.5007 26.8333C31.5007 33.1756 26.3429 38.3333 20.0007 38.3333C13.6584 38.3333 8.50065 33.1756 8.50065 26.8333ZM39.1673 26.8333C39.1673 37.4191 30.5845 46 20.0007 46C9.41682 46 0.833984 37.4191 0.833984 26.8333C0.833984 16.2476 9.41682 7.66667 20.0007 7.66667C30.5845 7.66667 39.1673 16.2476 39.1673 26.8333ZM35.334 26.8333C35.334 18.3789 28.4551 11.5 20.0007 11.5C11.5462 11.5 4.66732 18.3789 4.66732 26.8333C4.66732 35.2878 11.5462 42.1667 20.0007 42.1667C28.4551 42.1667 35.334 35.2878 35.334 26.8333ZM23.834 4.18025V0H16.1673V4.18025C18.866 3.72408 21.0778 3.7145 23.834 4.18025ZM36.6354 10.9921L39.1673 8.46017L36.4572 5.75L33.7604 8.44675C34.7877 9.21725 35.7499 10.0644 36.6354 10.9921Z",
    fill: "#0B0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingList);
export default __webpack_public_path__ + "static/media/bookingList.2f3e16ceb3b6e6023ee5d3c5cf763856.svg";
export { ForwardRef as ReactComponent };